<div class="search-container">
    <lib-search-input [(value)]="searchInput" (valueChange)="handleSearchInputChange()" (search)="search()">
    </lib-search-input>

    <button (click)="opencreateDialog()" mat-icon-button [matTooltip]="language.Erstellen | translationPipe">

        <mat-icon>add</mat-icon>
    </button>
</div>

<cdk-virtual-scroll-viewport [itemSize]="100">
    <mat-card appearance="outlined" *cdkVirtualFor="let safetypoint of safetypointList"
        (click)="handleSafetypointClick(safetypoint)">
        <mat-card-header>
            <doc-image mat-card-avatar [dataTypeID]="3" [dataID]="safetypoint.SafetyPointId" [cache]="true" style="margin:10px;"></doc-image>
            <mat-card-title-group>
                <mat-card-title>{{safetypoint.Bezeichnung}}</mat-card-title>

                <mat-card-subtitle *ngIf="isValidUrl(safetypoint.AssetLink)">
                    <a [href]="safetypoint.AssetLink" target="_blank" rel="noopener noreferrer"
                        style="text-decoration: none; color: inherit;">
                        {{ safetypoint.AssetLink }}
                    </a>
                </mat-card-subtitle>

            </mat-card-title-group>
            <button mat-icon-button (click)="handleInfoButtonClick($event, safetypoint)">
                <mat-icon>photo_library</mat-icon>
            </button>
            <button mat-icon-button (click)="handleEditButtonClick($event, safetypoint)">
                <mat-icon>edit</mat-icon>
            </button>
        </mat-card-header>
        <mat-card-content>


            <div class="info-table">

                <ng-container *ngIf="safetypoint.Debitorname">
                    <div class="label">{{ language.debitor | translationPipe }}:</div>
                    <div>{{ safetypoint.Debitorname }}</div>
                </ng-container>

                <ng-container *ngIf="safetypoint.StandortBezeichnung">
                    <div class="label">{{ language.Standort | translationPipe }}:</div>
                    <div>{{ safetypoint.StandortBezeichnung }}</div>
                </ng-container>

                <ng-container *ngIf="safetypoint.ObjektBezeichnung">
                    <div class="label">{{ language.objekt | translationPipe }}:</div>
                    <div>{{ safetypoint.ObjektBezeichnung }}</div>
                </ng-container>

                <ng-container *ngIf="safetypoint.RoofareaBezeichnung">
                    <div class="label">{{ language.roofarea | translationPipe }}:</div>
                    <div>{{ safetypoint.RoofareaBezeichnung }}</div>
                </ng-container>

                <ng-container *ngIf="safetypoint.SicherungssystemBezeichnung">
                    <div class="label">{{ language.Sicherungssystem | translationPipe }}:</div>
                    <div>{{ safetypoint.SicherungssystemBezeichnung }}</div>
                </ng-container>

            </div>


        </mat-card-content>
    </mat-card>
</cdk-virtual-scroll-viewport>